import type { Price } from './content'


export interface IApiResponse<T = any> {
  data: T
  meta?: Record<string, any>
  links?: Record<string, string>
}

export class IApiError extends Error {
  errors: Record<string, string>
  status?: number
  
  constructor(message: string, errors: Record<string, string> = {}, status?: number) {
    super(message)
    this.name = 'ApiError'
    this.errors = errors
    this.status = status
  }

  hasError(field: string): boolean {
    return field in this.errors
  }

  getError(field: string): string {
    return this.errors[field] || ''
  }
}